import React from 'react';
import Box from '@mui/material/Box';

export default function SmallestHeading(props) {
    return (
        <Box sx={{ fontSize: '1.5em', marginTop: '7px', ...(props.sx || {}) }}
            onClick={props.onClick}>
            {props.children}</Box>
    )
}
